import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { login as apiLogin, forgotPassword } from '../api/api';
import { AuthLanding, AuthModal } from '../components/AuthShell';

function Login() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [mode, setMode] = useState(null); // null | 'login' | 'forgot'
  const [form, setForm] = useState({ email: '', password: '' });
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotMsg, setForgotMsg] = useState(null);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    axios.get('/api/profile', { withCredentials: true })
      .then(() => navigate('/dashboard'))
      .catch(() => setChecking(false));
  }, [navigate]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await apiLogin(form);
      navigate('/dashboard');
      window.location.reload();
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo iniciar sesión');
    }
    setSubmitting(false);
  };

  const handleForgot = async (e) => {
    e.preventDefault();
    setForgotMsg(null);
    try {
      const res = await forgotPassword(forgotEmail);
      setForgotMsg(res.data.message || 'Si el correo existe, se generó un link de recuperación.');
    } catch (err) {
      setForgotMsg('No se pudo procesar la solicitud.');
    }
  };

  if (checking) return <div className="state-message"><p>Cargando...</p></div>;

  return (
    <AuthLanding>
      <div className="login-cta-row">
        <button type="button" className="btn btn-primary login-cta-btn" onClick={() => setMode('login')}>
          Entrar a mi cuenta
        </button>
        <p className="login-cta-hint">
          ¿Aún no eres miembro? <Link to="/registro">Únete a la red</Link>
        </p>
      </div>

      {mode === 'login' && (
        <AuthModal title="Iniciar sesión" onClose={() => { setMode(null); setError(null); }}>
          <form onSubmit={handleSubmit}>
            {error && <div className="msg-banner error">{error}</div>}
            <div className="form-group">
              <label className="form-label">Correo electrónico</label>
              <input type="email" name="email" value={form.email} onChange={handleChange} required className="form-input" autoFocus />
            </div>
            <div className="form-group">
              <label className="form-label">Contraseña</label>
              <input type="password" name="password" value={form.password} onChange={handleChange} required className="form-input" />
            </div>
            <button type="submit" disabled={submitting} className="btn btn-primary btn-block" style={{ marginBottom: '10px' }}>
              {submitting ? 'Entrando...' : 'Entrar'}
            </button>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}>
              <button type="button" className="link-button" onClick={() => { setMode('forgot'); setError(null); }}>
                Olvidé mi contraseña
              </button>
              <Link to="/registro">Crear cuenta</Link>
            </div>
          </form>
        </AuthModal>
      )}

      {mode === 'forgot' && (
        <AuthModal title="Recuperar contraseña" onClose={() => setMode(null)}>
          <form onSubmit={handleForgot}>
            {forgotMsg && <div className="msg-banner success">{forgotMsg}</div>}
            <div className="form-group">
              <label className="form-label">Correo electrónico</label>
              <input type="email" value={forgotEmail} onChange={(e) => setForgotEmail(e.target.value)} required className="form-input" autoFocus />
            </div>
            <button type="submit" className="btn btn-primary btn-block" style={{ marginBottom: '10px' }}>Enviar link de recuperación</button>
            <button type="button" className="link-button" onClick={() => setMode('login')}>Volver a iniciar sesión</button>
          </form>
        </AuthModal>
      )}
    </AuthLanding>
  );
}

export default Login;
